"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _popper = _interopRequireDefault(require("popper.js"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _styles2 = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Popper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popper, _React$Component);

  function Popper(props) {
    var _this;

    _classCallCheck(this, Popper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popper).call(this, props));
    _this.state = {
      renderedPlacement: props.placement
    };
    _this.popperNodeRef = _react["default"].createRef();
    _this.arrowNodeRef = _react["default"].createRef();
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          open = _this$props.open,
          anchorEl = _this$props.anchorEl,
          popperOptions = _this$props.popperOptions,
          modifiers = _this$props.modifiers,
          placement = _this$props.placement;
      var closePopper = prevProps.open !== open && !open;
      var openPopper = prevProps.open !== open || prevProps.anchorEl !== anchorEl || prevProps.popperOptions !== popperOptions || prevProps.modifiers !== modifiers || prevProps.placement !== placement;
      if (closePopper) this.handleClose();
      if (openPopper) this.handleOpen();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleClose();
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this2 = this;

      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          modifiers = _this$props2.modifiers,
          open = _this$props2.open,
          placement = _this$props2.placement,
          hideArrow = _this$props2.hideArrow,
          _this$props2$popperOp = _this$props2.popperOptions,
          popperOptions = _this$props2$popperOp === void 0 ? {} : _this$props2$popperOp;
      var popperNode = this.popperNodeRef.current;
      if (!popperNode || !anchorEl || !open) return;
      this.handleClose();
      this.popper = new _popper["default"](anchorEl, popperNode, _objectSpread({
        placement: placement
      }, popperOptions, {
        modifiers: _objectSpread({
          preventOverflow: {
            boundariesElement: 'window'
          },
          arrow: hideArrow ? {} : {
            element: this.arrowNodeRef.current
          }
        }, modifiers, {}, popperOptions.modifiers),
        onCreate: function onCreate(data) {
          _this2.setState({
            renderedPlacement: data.placement
          });
        },
        onUpdate: function onUpdate(data) {
          var renderedPlacement = _this2.state.renderedPlacement;

          if (data.placement !== renderedPlacement) {
            _this2.setState({
              renderedPlacement: data.placement
            });
          }
        }
      }));
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      if (!this.popper) return;
      this.popper.destroy();
      this.popper = null;
    }
  }, {
    key: "render",
    value: function render() {
      var renderedPlacement = this.state.renderedPlacement;

      var _this$props3 = this.props,
          anchorEl = _this$props3.anchorEl,
          backgroundColor = _this$props3.backgroundColor,
          borderColor = _this$props3.borderColor,
          children = _this$props3.children,
          classes = _this$props3.classes,
          hideArrow = _this$props3.hideArrow,
          modifiers = _this$props3.modifiers,
          open = _this$props3.open,
          placement = _this$props3.placement,
          popperOptions = _this$props3.popperOptions,
          uncontained = _this$props3.uncontained,
          props = _objectWithoutProperties(_this$props3, ["anchorEl", "backgroundColor", "borderColor", "children", "classes", "hideArrow", "modifiers", "open", "placement", "popperOptions", "uncontained"]);

      if (!open) return null;
      /*
       * This is a hack to fix improper positioning of popovers in Safari.
       * This may be related to these `popper.js` issues:
       *
       * - [Incorrect placement of popper if ref is in flex container with odd-numbered height][#455]
       * - [Misplacement when popper element is in a positioned element][#628]
       * - [Popper element positions incorrectly initially][#796]
       *
       * This should incur a negligible performance cost in terms of unnecessary repaints. If you feel this cost is
       * too high or you have a better solution, please speak up in the #guild-component-library Slack channel.
       *
       * [#455]: https://github.com/FezVrasta/popper.js/issues/455
       * [#628]: https://github.com/FezVrasta/popper.js/issues/628
       * [#796]: https://github.com/FezVrasta/popper.js/issues/796
       */

      if (this.popper) {
        this.popper.update();
      }

      return _react["default"].createElement("div", _extends({
        role: "tooltip",
        ref: this.popperNodeRef,
        className: classes.root
      }, props), children, !hideArrow && _react["default"].createElement("div", {
        ref: this.arrowNodeRef,
        className: classes["".concat(renderedPlacement.split('-')[0], "Arrow")]
      }));
    }
  }]);

  return Popper;
}(_react["default"].Component);

Popper.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of Popper component */
  children: _propTypes["default"].node,

  /** The reference element used to position the popper */
  anchorEl: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types

  /** Bool flag to open/close the popper */
  open: _propTypes["default"].bool.isRequired,

  /** Placement can be either of the following */
  placement: _propTypes["default"].oneOf(['top', 'top-end', 'top-start', 'right', 'right-end', 'right-start', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start']),

  /** Bool flag to determine whether to show/hide the arrow */
  hideArrow: _propTypes["default"].bool,

  /** Background color for the popper element */
  backgroundColor: _propTypes["default"].string,

  /** Border color for the popper element */
  borderColor: _propTypes["default"].string,

  /** Bool flag to determine if the popper element is contained in the anchor element or not */
  uncontained: _propTypes["default"].bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   */
  modifiers: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * Options provided to the popper instance.
   */
  popperOptions: _propTypes["default"].object // eslint-disable-line react/forbid-prop-types

};
Popper.defaultProps = {
  children: null,
  anchorEl: null,
  placement: 'bottom',
  hideArrow: false,
  backgroundColor: _styles2.colors.white,
  borderColor: _styles2.colors.gray,
  uncontained: false,
  modifiers: {},
  popperOptions: {}
};

var _default = (0, _withStyles["default"])(_styles["default"])(Popper);

exports["default"] = _default;